import {
    PASSWORD_MIN_LENGTH,
    REGEX_HAS_UPPERCASE,
    REGEX_HAS_LOWERCASE,
    REGEX_HAS_DIGIT,
    REGEX_HAS_SPECIAL_CHAR,
} from '../constants';

export interface ValidateOutput {
    isValid: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rules: any;
}

export interface ValidatePasswordOutput extends ValidateOutput {
    rules: {
        hasUppercaseLetter: boolean;
        hasLowercaseLetter: boolean;
        hasNumber: boolean;
        hasSpecialChar: boolean;
        hasMinimumChars: boolean;
    };
}

export const validatePassword: (password: string) => ValidatePasswordOutput = (password) => {
    const hasUppercaseLetter = REGEX_HAS_UPPERCASE.test(password);
    const hasLowercaseLetter = REGEX_HAS_LOWERCASE.test(password);
    const hasNumber = REGEX_HAS_DIGIT.test(password);
    const hasSpecialChar = REGEX_HAS_SPECIAL_CHAR.test(password);
    const hasMinimumChars = password.length >= PASSWORD_MIN_LENGTH;

    return {
        isValid: hasUppercaseLetter && hasLowercaseLetter && hasNumber && hasSpecialChar && hasMinimumChars,
        rules: {
            hasUppercaseLetter,
            hasLowercaseLetter,
            hasNumber,
            hasSpecialChar,
            hasMinimumChars,
        },
    };
};
